module.exports = __webpack_public_path__ + "img/25f1320.webp";